var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"el",staticClass:"tag-reference",class:("tag-reference--tail-" + _vm.tailPosition),style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.label)}})}
var staticRenderFns = []

export { render, staticRenderFns }